import React from 'react';
import { Alert, Typography, Fade } from '@mui/material';

const RecommendationsErrorState = ({ error }) => {
  if (!error) return null;

  return (
    <Fade in timeout={300}>
      <Alert 
        severity="error" 
        sx={{ 
          mb: 3,
          borderRadius: 2,
          border: '1px solid #fc8181',
          '& .MuiAlert-icon': {
            fontSize: 24
          }
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {typeof error === 'string' ? error : error?.response?.data?.detail || error?.message || 'An unexpected error occurred'}
        </Typography>
      </Alert>
    </Fade>
  );
};

export default RecommendationsErrorState;
